import { atom, useAtomValue, useSetAtom } from 'jotai';

const refetchProjectsStatusAtom = atom(1);

export const useRefetchProjects = () => {
  const refetchProjects = useAtomValue(refetchProjectsStatusAtom);
  const updateRefetchProjectsStatus = useSetAtom(refetchProjectsStatusAtom);

  return {
    refetchProjects,
    updateRefetchProjectsStatus,
  };
};
